export default __webpack_public_path__ + "7c47efd0b1b67bf05ee1d7c9378e74d6.svg";